import Button from '@/components/Button';
import { FiAlertTriangle } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import useUser from '@/hooks/useUser';
import { setModalState } from '@/redux/actions/uiActions/modalActions';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import { modal } from '@/redux/selectors/uiSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const PlatformAdminTwoFactorSplash = () => {
  const { jwt } = useUser();
  const userProfileModalState = useSelector(memoizeSelector('modal:userProfile', (state) => modal(state, 'userProfile')));

  const admin = useMemo(() => jwt?.admin, [jwt?.admin]);
  const twoFactorEnabled = useMemo(() => jwt?.twoFactorEnabled, [jwt?.twoFactorEnabled]);
  const isUserProfileModalOpen = userProfileModalState?.open;

  const handleClick = () => {
    setModalState('userProfile', { open: true });
  };

  if (!admin || twoFactorEnabled || isUserProfileModalOpen) {
    return null;
  }

  return (
    <div className="platform-loader">
      <div className="content">
        <IconV2 icon={FiAlertTriangle} size={24} className="warning" />
        <p>
          You must enable two-factor authentication to continue using the platform. <br />
          To set it up, click on the button below and go to the security tab.
        </p>
        <Button onClick={handleClick}>Setup two-factor authentication</Button>
      </div>
    </div>
  );
};

export default PlatformAdminTwoFactorSplash;
